import { assertNonNullable, assertTrue } from "./assert";

export interface DocumentReference {
	readonly model: string;
	readonly id: string;
}

export const DocumentReference = {
	toString(docRef: DocumentReference): string {
		return `${docRef.model}/${docRef.id}`;
	},
	fromString(instance: string): DocumentReference {
		const [model, id, ...rest] = instance.split("/");
		assertNonNullable(model);
		assertNonNullable(id);
		assertTrue(rest.length === 0);
		return { model, id };
	}
};
